function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_70303",
  "data-name": "Group 70303",
  transform: "translate(-1198 -709)"
}, /*#__PURE__*/React.createElement("path", {
  id: "polygon9",
  d: "M439.514,133.959h-6.007l3.757-23.233h6.007Z",
  transform: "translate(829.621 598.695)",
  fill: "#00579f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path11",
  d: "M583.2,106.037a14.8,14.8,0,0,0-5.388-.989c-5.932,0-10.11,3.163-10.135,7.686-.049,3.337,2.991,5.19,5.265,6.3,2.324,1.137,3.114,1.879,3.114,2.892-.024,1.556-1.878,2.274-3.608,2.274a11.956,11.956,0,0,1-5.636-1.236l-.791-.371-.841,5.215a18.283,18.283,0,0,0,6.7,1.236c6.3,0,10.407-3.114,10.455-7.934.024-2.645-1.581-4.671-5.042-6.327-2.1-1.063-3.388-1.78-3.388-2.867.025-.989,1.088-2,3.46-2a10.206,10.206,0,0,1,4.475.89l.543.247.817-5.017Z",
  transform: "translate(707.713 603.953)",
  fill: "#00579f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path13",
  d: "M799.816,125.729c.495-1.335,2.4-6.5,2.4-6.5-.025.05.494-1.359.79-2.224l.42,2s1.138,5.561,1.385,6.723Zm7.415-15h-4.647a2.964,2.964,0,0,0-3.14,1.928l-8.923,21.3h6.3s1.038-2.867,1.261-3.485H805.8c.172.816.717,3.485.717,3.485h5.562l-4.846-23.232Z",
  transform: "translate(499.08 598.695)",
  fill: "#00579f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path15",
  d: "M180.667,110.727l-5.883,15.842-.643-3.213a17.782,17.782,0,0,0-8.305-9.738l5.389,20.317h6.352l9.442-23.208Z",
  transform: "translate(1077.443 598.695)",
  fill: "#00579f"
}), /*#__PURE__*/React.createElement("path", {
  id: "path17",
  d: "M90.93,110.727H81.265l-.1.469c7.539,1.928,12.532,6.575,14.584,12.161l-2.1-10.677c-.346-1.484-1.409-1.9-2.719-1.953Z",
  transform: "translate(1155.834 598.695)",
  fill: "#faa61a"
}), /*#__PURE__*/React.createElement("g", {
  id: "g15",
  transform: "translate(1199.566 729.389)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1775_",
  d: "M2953.441,2902.292V2900.7a.934.934,0,0,0-1.009-1.009,1.048,1.048,0,0,0-.9.451.928.928,0,0,0-.85-.451.857.857,0,0,0-.743.372v-.319h-.558v2.549h.558v-1.407c0-.451.239-.664.61-.664s.557.239.557.664v1.407h.558v-1.407a.587.587,0,0,1,.61-.664c.372,0,.558.239.558.664v1.407Zm8.257-2.549h-.9v-.77h-.558v.77h-.5v.5h.5v1.168c0,.584.239.929.876.929a1.484,1.484,0,0,0,.69-.186l-.159-.478a.873.873,0,0,1-.478.133c-.265,0-.371-.159-.371-.425v-1.141h.9Zm4.726-.053a.748.748,0,0,0-.664.372v-.319h-.558v2.549h.558v-1.434c0-.425.186-.664.531-.664a1.549,1.549,0,0,1,.345.053l.16-.531a1.753,1.753,0,0,0-.372-.027Zm-7.141.265a1.823,1.823,0,0,0-1.035-.265c-.637,0-1.062.319-1.062.823,0,.425.319.664.876.743l.266.027c.292.053.451.133.451.265,0,.186-.212.319-.584.319a1.464,1.464,0,0,1-.85-.266l-.266.425a1.878,1.878,0,0,0,1.088.319c.743,0,1.168-.345,1.168-.823,0-.451-.345-.69-.876-.77l-.265-.027c-.239-.027-.425-.08-.425-.239,0-.186.186-.292.478-.292a1.917,1.917,0,0,1,.8.212Zm14.814-.265a.748.748,0,0,0-.664.372v-.319h-.557v2.549h.557v-1.434c0-.425.186-.664.531-.664a1.553,1.553,0,0,1,.345.053l.159-.531a1.744,1.744,0,0,0-.371-.027Zm-7.115,1.327a1.275,1.275,0,0,0,1.354,1.327,1.321,1.321,0,0,0,.9-.292l-.266-.451a1.072,1.072,0,0,1-.664.239.754.754,0,0,1-.77-.823.783.783,0,0,1,.77-.823,1.072,1.072,0,0,1,.664.239l.266-.451a1.321,1.321,0,0,0-.9-.292,1.275,1.275,0,0,0-1.354,1.327Zm5.15,0v-1.274h-.558v.319a.959.959,0,0,0-.8-.372,1.328,1.328,0,0,0,0,2.655.893.893,0,0,0,.8-.372v.319h.558Zm-2.044,0a.771.771,0,1,1,1.54,0,.771.771,0,1,1-1.54,0Zm-6.664-1.327a1.328,1.328,0,0,0,.027,2.655,1.623,1.623,0,0,0,1.035-.345l-.265-.4a1.269,1.269,0,0,1-.744.266.716.716,0,0,1-.77-.611h1.885v-.212a1.173,1.173,0,0,0-1.168-1.354Zm0,.478a.621.621,0,0,1,.637.611h-1.327a.672.672,0,0,1,.69-.611Zm13.832.85v-2.283h-.558v1.327a.959.959,0,0,0-.8-.372,1.328,1.328,0,0,0,0,2.655.893.893,0,0,0,.8-.372v.319h.558Zm-2.045,0a.772.772,0,1,1,1.54,0,.772.772,0,1,1-1.54,0Zm-18.637,0v-1.274h-.557v.319a.959.959,0,0,0-.8-.372,1.328,1.328,0,0,0,0,2.655.893.893,0,0,0,.8-.372v.319h.557Zm-2.071,0a.772.772,0,1,1,1.54,0,.772.772,0,1,1-1.54,0Z",
  transform: "translate(-2949.379 -2898.734)"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_328_",
  transform: "translate(1198 709)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect19",
  width: 8.363,
  height: 15.027,
  transform: "translate(11.283 2.044)",
  fill: "#ff5f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_330_",
  d: "M2910.549,2249.06a9.582,9.582,0,0,1,3.637-7.513,9.558,9.558,0,1,0,0,15.026A9.543,9.543,0,0,1,2910.549,2249.06Z",
  transform: "translate(-2898.734 -2239.502)",
  fill: "#eb001b"
}), /*#__PURE__*/React.createElement("path", {
  id: "path22",
  d: "M3414.619,2249.06a9.547,9.547,0,0,1-15.451,7.513,9.579,9.579,0,0,0,0-15.026,9.547,9.547,0,0,1,15.451,7.513Z",
  transform: "translate(-3383.69 -2239.502)",
  fill: "#f79e1b"
})));

var SvgBankss = function SvgBankss(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113.157,
    height: 24,
    viewBox: "0 0 113.157 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bankss.e185da90.svg";
export { ForwardRef as ReactComponent };